import {
  GET_TRX_REQ_FAILED,
  GET_TRX_REQ_LOADING,
  GET_TRX_REQ_SUCCESS,
  GET_TRX_RES_FAILED,
  GET_TRX_RES_LOADING,
  GET_TRX_RES_SUCCESS,
} from "../types";

const initialState = {
  trxData: null,
  loading: null,
  error: null,
};

const getTrxReqReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_TRX_REQ_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_TRX_REQ_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        trxData: action.payload,
      };
    case GET_TRX_REQ_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

const getTrxResReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_TRX_RES_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_TRX_RES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        trxData: action.payload,
      };
    case GET_TRX_RES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export { getTrxReqReducer, getTrxResReducer };
